import React from 'react'

const CustomerDashboard = () => {
  return (
    <div>CustomerDashboard</div>
  )
}

export default CustomerDashboard